import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { MaintenanceBannerColor } from '../../model';

const MAINTENANCE_BANNER_BACKGROUND_COLORS: Record<MaintenanceBannerColor, string> = {
    beige: getPurpurColor('backgroundToneOnToneQuaternary'),
    blue: getPurpurColor('backgroundStatusInfoMedium'),
    red: getPurpurColor('backgroundStatusErrorMedium'),
};

const MAINTENANCE_BANNER_TEXT_COLORS: Record<MaintenanceBannerColor, string> = {
    beige: getPurpurColor('textToneOnToneTertiary'),
    blue: getPurpurColor('blue900'),
    red: getPurpurColor('textStatusErrorStrong'),
};

export const StyledMaintenanceBanner = styled.div<{ $color: MaintenanceBannerColor }>`
    position: relative;
    background-color: ${({ $color }) => MAINTENANCE_BANNER_BACKGROUND_COLORS[$color]};
`;

export const ContentContainer = styled(Container)<{ $color: MaintenanceBannerColor }>`
    line-height: ${getPurpurTypography('scale200')};
    color: ${({ $color }) => MAINTENANCE_BANNER_TEXT_COLORS[$color]};
    font-size: ${getPurpurTypography('scale100')};
    font-weight: ${getPurpurTypography('weightMedium')};
    padding-top: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('200')};
    padding-right: ${getPurpurSpacing('600')};
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    top: ${getPurpurSpacing('50')};
    right: ${getPurpurSpacing('50')};
`;
